import {BUYERS} from "../../constants/buyers";

export function fetchBuyers(params) {
    return {
        type: BUYERS.FETCH_BUYERS.MAIN,
        params
    }
}
